import { styled } from '@linaria/react'
import { minimalVars as v } from '@ovasabi/ui-minimal/tokens'

export const BoardSurface = styled.div`
  width: 100%;
  color: ${v.color.textPrimary};
  background: ${v.color.bgApp};
  font-size: 16px;
  line-height: 1.5;
  h1,
  h2,
  h3,
  p {
    margin: 0;
  }
  h1 {
    font-size: ${v.typography.h1Size};
    line-height: ${v.typography.lineHeightTight};
  }
  h2 {
    font-size: ${v.typography.h2Size};
    line-height: ${v.typography.lineHeightTight};
  }
  h3 {
    font-size: ${v.typography.h2Size};
    line-height: ${v.typography.lineHeightBody};
  }
  p {
    line-height: 1.6;
  }
  button,
  input {
    min-height: 44px;
  }
  button {
    white-space: normal;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 700;
  }
  [data-minimal='SegmentedControl'] {
    flex-shrink: 0;
  }
  [data-minimal='SegmentedControl'] button {
    white-space: nowrap;
    min-width: 80px;
  }
  [data-minimal='Alert'] {
    color: ${v.color.textPrimary};
    font-size: 14px;
    display: block;
    padding: 12px 16px;
  }
  [data-minimal='Dropdown'] [role='combobox'] {
    padding: 12px 16px;
    min-height: 48px;
    font-size: 14px;
  }
  [data-minimal='Dropdown'] > [data-minimal-state],
  [data-minimal='Input'] > [data-minimal-state] {
    padding: 0;
  }
  [data-minimal='Input'] input {
    font-size: 16px;
    padding: 12px 16px;
  }
  [data-minimal='Input'] label,
  [data-minimal='Dropdown'] label,
  [data-minimal='NumberField'] label {
    font-size: 14px;
    line-height: 1.4;
  }
  * {
    min-width: 0;
    box-sizing: border-box;
  }
  [data-minimal='NumberField'] {
    width: 100%;
  }
  .skip {
    position: absolute;
    top: -100px;
  }
  .skip:focus {
    top: 0;
    z-index: 10;
    background: white;
  }
  .top {
    border-bottom: 1px solid ${v.color.borderSubtle};
  }
  .top-inner {
    max-width: 1140px;
    margin: auto;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .logo {
    width: 190px;
    height: auto;
  }
  .board-main {
    max-width: 1140px;
    margin: auto;
    padding: 0 0 24px;
    display: grid;
    gap: 20px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: end;
    flex-wrap: wrap;
    gap: 12px;
  }
  .place {
    width: 260px;
  }
  .muted {
    color: ${v.color.textSecondary};
    font-size: 14px;
  }
  .eyebrow {
    color: ${v.color.textTertiary};
    font-size: 13px;
    margin-bottom: 8px;
  }
  .row {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .stack {
    display: grid;
    gap: 16px;
  }
  .small-stack {
    display: grid;
    gap: 8px;
  }
  .view-nav {
    max-width: 440px;
  }
  .summary {
    display: flex;
    gap: 28px;
    flex-wrap: wrap;
    padding: 12px 0;
    border-block: 1px solid ${v.color.borderSubtle};
  }
  .summary strong {
    font-size: 24px;
    display: block;
    font-variant-numeric: tabular-nums;
  }
  .work {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;
    align-items: start;
  }
  .column {
    display: grid;
    gap: 12px;
  }
  .column-title {
    padding-bottom: 12px;
    border-bottom: 2px solid ${v.color.borderSubtle};
  }
  .ticket {
    padding: 16px;
    border: 1px solid ${v.color.borderSubtle};
    border-radius: ${v.radius.md};
    display: flex;
    flex-direction: column;
    min-height: 280px;
    gap: 16px;
  }
  .ticket > button {
    margin-top: auto;
    width: 100%;
  }
  .ticket ul {
    margin: 0;
    padding-left: 20px;
  }
  .ticket li {
    margin: 4px 0;
  }
  .note {
    padding-left: 12px;
    border-left: 3px solid ${v.color.borderStrong};
    font-size: 14px;
  }
  .empty {
    padding: 12px 0;
    color: ${v.color.textSecondary};
    font-size: 14px;
  }
  .lines {
    border-top: 1px solid ${v.color.borderSubtle};
  }
  .line {
    padding: 20px 0;
    border-bottom: 1px solid ${v.color.borderSubtle};
    display: grid;
    gap: 12px;
  }
  .day-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }
  .edit {
    background: ${v.color.bgSurfaceAlt};
    border-radius: ${v.radius.md};
    padding: 16px;
    display: grid;
    gap: 16px;
  }
  .stock-grid {
    display: grid;
    grid-template-columns: 1fr 230px;
    gap: 20px;
    align-items: start;
  }
  .saved {
    color: ${v.color.success};
    font-size: 14px;
  }
  .saved:empty {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
  .footer {
    border-top: 1px solid ${v.color.borderSubtle};
    padding-top: 16px;
  }
  @media (max-width: 760px) {
    .ticket {
      min-height: 0;
    }
    .work,
    .day-grid {
      grid-template-columns: 1fr;
    }
    .stock-grid {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 480px) {
    .board-main {
      padding: 0 0 24px;
      gap: 16px;
    }
    .top-inner {
      padding: 12px 16px;
    }
    .logo {
      width: 160px;
    }
    .place,
    .view-nav {
      width: 100%;
      max-width: none;
    }
    .summary {
      gap: 20px;
    }
  }
`
